import { SimpleGrid } from 'components'
import { useArcTranslation } from 'hooks'
import { useClassroomIntegrationEnabled } from 'integrations/classroom'
import { ManagerNavCard } from './ManagerNavCard'
import { CLASSROOM_NAVIGATION_ITEM, NAVIGATION_ITEMS } from './navigationItems'
import { GRID_BREAKPOINTS, GRID_COLS } from '../constants'

/** The management shortcut cards (School details, Faculty, Students — plus
 *  Google Classroom when the school has the flag). */
export const NavigationCards = () => {
  const { t } = useArcTranslation()
  const { enabled: classroomEnabled } = useClassroomIntegrationEnabled()
  const items = classroomEnabled ? [...NAVIGATION_ITEMS, CLASSROOM_NAVIGATION_ITEM] : NAVIGATION_ITEMS

  return (
    <SimpleGrid cols={GRID_COLS} spacing='md' breakpoints={GRID_BREAKPOINTS}>
      {items.map(({ key, icon, color, titleKey, descriptionKey, to }) => (
        <ManagerNavCard
          key={key}
          icon={icon}
          color={color}
          title={t(titleKey)}
          description={t(descriptionKey)}
          to={to}
        />
      ))}
    </SimpleGrid>
  )
}
